import { Injectable } from '@angular/core';
import { ArenaConfiguration } from './config.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  configuration: ArenaConfiguration;
  constructor() {}

  load(config): Promise<ArenaConfiguration> {
    return new Promise((resolve) => {
      this.configuration = config;
      resolve(this.configuration);
    });
  }
}
